module.exports = __webpack_public_path__ + "static/avatar_valeria_lanskaya-2106830a6acdd218676e0326a32ca553.jpg";